import React from "react";
import { clx } from "../utils/stringUtils";
import styles from "./CommonModal.module.scss";
import XIconThemed from "@src/assets/general-icons/XIconThemed";
import { useIsModalDraggable } from "./useModalDrag";

type IAllFilters = {
	controlSize?: "xsm" | "sm" | "msm" | "m" | "l" | "xl";
	title?: React.ReactElement | string;
	closeModal?: () => void;
	content?: React.ReactElement | string;
	buttons?: React.ReactElement | string;
	boldedHeader?: boolean;
	width?: number | string;
	padding?: number | string;
} & Omit<React.ComponentProps<"div">, "content">;

export const CommonModal: React.FC<IAllFilters> = ({
	controlSize = "m",
	title,
	content,
	buttons,
	width,
	closeModal,
	padding,
	boldedHeader = false,
	...rest
}) => {
	const isDraggable = useIsModalDraggable();

	return (
		<div style={{ width }} className={clx(styles.main, styles[controlSize])}>
			<div
				data-is-bold={boldedHeader}
				data-modal-drag-handle
				className={clx(styles.header, isDraggable ? styles.draggable : "")}>
				<div className={styles.headerTitle}>{title}</div>
				<div className={styles.headerIconContainer} data-no-drag aria-hidden="true" onClick={closeModal}>
					<XIconThemed color="#fafafa" />
				</div>
			</div>
			<div style={{ padding }} className={styles.content} {...rest}>
				{content}
			</div>
			{buttons ? <div className={styles.buttons}>{buttons}</div> : null}
		</div>
	);
};
